import { GroupConfig } from '@blockworks/platform/api/research/studio';

import {
    AreaPreview,
    AreaStackPreview,
    BarGroupPreview,
    BarStackPreview,
    BrushPreviewProps,
    LinePreview,
} from './group-preview';

const RICH_PREVIEWS = false;

const BrushPreview = function PreviewGroups<T extends {}>({
    visualizationId,
    groups,
    ...previewProps
}: BrushPreviewProps<T>) {
    return (
        <>
            {groups.flatMap(group => {
                const groupKey = [visualizationId, group.type, group.name].filter(Boolean).join('-');
                const key = `${groupKey}-preview-group`;
                let PreviewComponent: typeof LinePreview = LinePreview;

                if (RICH_PREVIEWS) {
                    if (group.type === 'bar') {
                        // For now these should be just rendered as lines for performance reasons
                        PreviewComponent = BarGroupPreview;
                        if (group.stack) {
                            PreviewComponent = BarStackPreview;
                        }
                    }

                    if (group.type === 'scatter') {
                        PreviewComponent = LinePreview;
                    }

                    if (group.type === 'area') {
                        PreviewComponent = AreaPreview;

                        if (group.stack) {
                            PreviewComponent = AreaStackPreview as typeof PreviewComponent;
                        }
                    }
                }
                return (
                    <PreviewComponent
                        key={key}
                        {...(previewProps as BrushPreviewProps<T>)}
                        groupKey={groupKey}
                        group={group as GroupConfig<any>}
                    />
                );
            })}
        </>
    );
};

BrushPreview.displayName = 'BrushPreview';

export { BrushPreview };
